<template>
  <div class="container-fluid content">
    <!-- Header mit Kontostand -->
    <balance-header/>
    <sakali-header title="Transferliste" class="mt-5"/>
    <!-- Liste der Transfer Requests -->
    <transfer-request-list/>
  </div>
</template>

<script>
import BalanceHeader from '../components/BalanceFixedTopWidget'
import TransferRequestList from "../components/transfer/TransferRequestList";

export default {
  data() {
    return {}
  },
  computed: {},
  methods: {},
  components: {
    BalanceHeader,
    TransferRequestList
  }
}
</script>

<style scoped>
</style>
